export default __webpack_public_path__ + "static/media/sponsor_kdan.04e4fe40.png";